export default "__VITE_ASSET__BFC1jtwc__"